import * as React from 'react';
import cx from 'classnames';
import Tooltip from 'components/Tooltip/SimpleTooltip';
import ProductRatingDetail from 'components/ProductRatingDetail/ProductRatingDetail';
import StarsWidget from 'components/StarsWidget/StarsWidget';
import get from 'lodash/get';
import shallowEqual from 'utils/shallowEqual';
import { formatAverageRating } from 'utils/ratingReviewUtil';
import StringWidget from 'components/StringWidget/StringWidget';
import { numFormat } from 'utils/numFormat';
import styles from './ProductRatingWidget.css';
export default class ProductRatingWidget extends React.Component {
    constructor(props) {
        super(props);
        this.handleRenderTooltip = () => {
            const { renderTooltip } = this.state;
            if (!renderTooltip) {
                this.setState({ renderTooltip: true });
            }
        };
        this.state = {
            renderTooltip: false
        };
    }
    shouldComponentUpdate(nextProps, nextState) {
        return this.state.renderTooltip !== nextState.renderTooltip || !shallowEqual(this.props, nextProps);
    }
    render() {
        const { product, view, ratingClass, position = 'bottom', detailPosition, idSuffix, containerClass, starsClass, starImgClass, isLifeStyleProduct = false } = this.props;
        const pid = this.props.pid || get(product, 'value.id');
        const lid = get(product, 'value.listingId');
        const productRatingId = `productRating_${lid}_${pid}_${idSuffix || ''}`;
        const rating = get(product, 'value.rating') || null;
        if (!rating || rating.average === 0)
            return null;
        const { count = 0, reviewCount = 0, average = 0 } = rating;
        const ratingCount = get(rating, 'ratingCount', 0);
        const ratingsCount = ratingCount || count;
        const ratingsCountStr = numFormat(ratingsCount);
        const reviewCountStr = numFormat(reviewCount);
        const widget = cx(styles['ugc-container'], containerClass, {
            [styles['minimal']]: view === 'minimal',
            [styles['lifestyle']]: isLifeStyleProduct
        });
        const tooltipStyle = detailPosition
            ? cx(styles['product-rating-popup'], styles[detailPosition], 'rating-tooltip')
            : cx(styles['product-rating-popup'], 'rating-tooltip');
        return (<div className={widget}>
				<span id={productRatingId} className={styles['rating-container']} onMouseEnter={this.handleRenderTooltip}>
					{average ? (<StarsWidget stars={formatAverageRating(average)} showStars starImgClass={starImgClass} className={starsClass}/>) : null}
					{this.state.renderTooltip && this.props.detailOnHover ? (<Tooltip anchor={`#${productRatingId}`} theme="light" position={position} lazy hoverInTimeout={100} hoverOutTimeout={100} className={tooltipStyle} activeClassName="rating-tooltip-visible" containerClassName={styles['product-rating-popup-container']}>
							<ProductRatingDetail rating={rating}/>
						</Tooltip>) : null}
				</span>
				{ratingsCount && this.props.showCount ? (<span className={cx(styles['reviews-count'], ratingClass)}>
						{view === 'minimal' ? (`(${ratingsCountStr})`) : isLifeStyleProduct ? (<StringWidget strKey="ratingAndReviewCount" attributes={{
            ratings: ratingsCountStr,
            rating_s: ratingsCount > 1 ? 's' : '',
            reviews: reviewCountStr,
            review_s: reviewCount > 1 ? 's' : ''
        }}/>) : (<span>
								<span>{`${ratingsCountStr} Ratings\xa0`}</span>
								<span className={styles['separator']}>&</span>
								<span>{`\xa0${reviewCountStr} Reviews`}</span>
							</span>)}
					</span>) : null}
			</div>);
    }
}
ProductRatingWidget.defaultProps = {
    showCount: true
};
